// ** Third Party Components
import styled from "styled-components";

//##################################

export const ControlsSectionStyled = styled("div")`
	position: absolute;
	bottom: 0.75rem;
	right: 1rem;
	display: flex;
	flex-direction: row;
	justify-content: end;
	z-index: 3;
`;

export const ControlsSectionSide = styled("div")`
	display: flex;
	flex-direction: column;
	align-items: end;
`;

//##################################

const ControlsSection = ({ right }) => {
	return (
		<ControlsSectionStyled>
			<ControlsSectionSide>{right}</ControlsSectionSide>
		</ControlsSectionStyled>
	);
};

export default ControlsSection;
